export default function StackedBarchartSettings(QdtComponents) {
  if (process.client) {
    const settings = QdtComponents.picasso.settings.stackedBarchart

    // in order to not impact original stackedBarchart object make copies of arrays
    if (settings.component) settings.components = settings.components.slice()
    if (settings.collections)
      settings.collections = settings.collections.slice()

    // remove and create new interactions
    delete settings.interactions
    settings.interactions = [
      {
        type: 'native',
        events: {
          mousemove(e) {
            const tooltip = this.chart.component('tooltip-custom')
            tooltip.emit('show', e, {
              data: settings.scales.c.data
            })
          },
          mouseleave() {
            const tooltip = this.chart.component('tooltip-custom')
            tooltip.emit('hide')
          },
          click(e) {
            e.cancelBubble = true
            return false
            // if (e.target.getAttribute('data-component-key') === 'cat')
            //   this.chart
            //     .component(e.target.getAttribute('data-component-key'))
            //     .emit(e.target.getAttribute('data-action'))
          }
        }
      }
    ]

    // update scales
    settings.scales.y.min = 0
    settings.scales.y.ticks = {
      distance: 50
    }
    settings.scales.c.type = 'categorical-color'
    // can update colors by supplying, as such
    // settings.scales.c.range = ['#3399CC', '#CC6666', '#99CC66']

    /////////////////////////////// COMPONENTS ////////////////////////////////

    // grid
    if (
      settings.components.filter(component => component.type === 'grid-line')
        .length === 0
    )
      settings.components.push({
        type: 'grid-line',
        y: {
          scale: 'y'
        },
        ticks: {
          show: true,
          stroke: 'lightgray'
        }
      })

    // update axes
    let xaxis = settings.components.filter(c => c.key === 'x-axis')
    if (xaxis && xaxis.length > 0) xaxis[0].settings.labels.maxLengthPx = 85

    let yaxis = settings.components.filter(c => c.key === 'y-axis')
    if (yaxis && yaxis.length > 0) {
      yaxis[0].formatter = {
        formatter: 'd3', // The type of formatter to use
        type: 'number', // The type of data to format
        format: ',.2r' // Format pattern
      }
    }

    // update labels
    let labels = settings.components.filter(c => c.type === 'labels')
    if (labels && labels.length > 0) {
      labels.forEach(label => {
        label.settings.sources[0].strategy.settings.labels[0].label = function({
          data
        }) {
          return (
            data?.end?.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') ||
            ''
          )
        }
        label.settings.sources[0].strategy.settings.labels[0].placements = [
          { fill: '#666', position: 'outside', float: 'right' }
        ]
      })
    }

    // legend
    if (
      settings.components.filter(component => component.type === 'legend-cat')
        .length === 0
    ) {
      settings.components.push({
        key: 'cat',
        type: 'legend-cat',
        scale: 'c',
        dock: 'right',
        settings: {
          layout: {
            size: 1, // Optional
            direction: 'ltr' // Optional
          },
          item: {
            label: {
              show: true,
              wordBreak: 'none'
            },
            shape: {
              type: 'square',
              size: 8
            }
          },
          title: {
            show: false
          }
        }
      })
    }

    // tooltip
    if (
      settings.components.filter(
        component => component.key === 'tooltip-custom'
      ).length === 0
    ) {
      settings.components.push({
        displayOrder: 10,
        key: 'tooltip-custom',
        type: 'tooltip',
        settings: {
          filter: function filter(nodes) {
            return nodes.filter(node => node.key === 'bar')
          },
          extract: function extract({ node }) {
            return {
              data: node.data,
              key: node.key
            }
          },
          // Generate virtual nodes
          content: ({ h, data }) => {
            var html = ''
            const title = ''.concat(data[0]?.data?.label || '')
            const body = ''
              .concat(data[0]?.data?.series?.label || '', ': ')
              .concat(
                isFinite(data[0]?.data?.end?.value) &&
                  isFinite(data[0]?.data?.start?.value)
                  ? (data[0].data.end.value - data[0].data.start.value)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                  : ''
              )

            // Stacked
            html = h('div.qdt-tooltip-header', {}, [
              h(
                'div.qdt-tooltip-header-title',
                {
                  align: 'center',
                  style: {
                    'border-bottom': '1px solid rgba(255,255,255,0.2)',
                    'padding-bottom': '5px',
                    display: 'block'
                  }
                },
                title
              ),
              h(
                'div.qdt-tooltip-header-measure',
                {
                  align: 'center',
                  style: {
                    'padding-top': '55px'
                  }
                },
                body
              )
            ])
            return h(
              'div',
              {
                display: 'table'
              },
              html
            )
          },
          afterShow: function afterShow({ element }) {
            element.children[0].style.opacity = 1
            element.children[1].style.opacity = 1
          },
          onHide: function onHide({ element }) {
            element.children[0].style.opacity = 0
            element.children[1].style.opacity = 0
          },
          placement: {
            type: 'pointer',
            area: 'target'
          }
        },
        style: {
          content: {
            'border-spacing': '4px',
            opacity: 0,
            transition: 'opacity 150ms ease-in'
          },
          arrow: {
            opacity: 0,
            transition: 'opacity 150ms ease-in'
          }
        }
      })
    }

    return settings
  } else {
    return {}
  }
}
